/* eslint-disable max-len */
/* eslint-disable no-shadow */
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import api from '../config/axios';
import TextAreaInput from './TextAreaInput';

type PagVipRefProps = {
  id: number,
  pagazulHolderLinksId: number,
  idCharge: string,
  bankSlip: string,
  createdAt: string,
  updatedAt: string,
}

interface PageProps {
    id: string,
    title: string,
    isPf: boolean,
    galaxpayInstallmentId: string,
    fetchPayment: () => void
}

enum ActualPage {
  FORM,
  LOADING,
  SUCCESS,
  ERROR
}

export default function CancelGalaxPayChargeModal({
  id, title, fetchPayment, isPf, galaxpayInstallmentId,
}: PageProps) {
  const [reason, setReason] = useState('');
  const [actualPage, setActualPage] = useState(ActualPage.FORM);
  const [token] = useState({ headers: { Authorization: `bearer ${localStorage.getItem('adminToken')}` } });
  const [error, setError] = useState('');

  async function tryCancelCharge() {
    try {
      setActualPage(ActualPage.LOADING);
      const route = isPf ? `/admin/galaxpay/boleto-pf/installment/${galaxpayInstallmentId}` : `/admin/galaxpay/boleto-pj/installment/${galaxpayInstallmentId}`;
      const response = await api.delete(route, token);
      console.log(response.data);
      setActualPage(ActualPage.SUCCESS);
    } catch (err: any) {
      console.log('erro ao cancelar boleto', err.response.data);
      if (err.response) {
        if (err.response.data.error) {
          setError(err.response.data.error);
        }
      }
      setActualPage(ActualPage.ERROR);
    }
  }

  function closeAndFetch() {
    window.location.reload();
  }
  return (
    <div className="modal fade" id={id} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="staticBackdropLabel">{title}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closeAndFetch()} />
          </div>
          <div className="modal-body">

            { actualPage === ActualPage.LOADING && (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 400 }}>
              <p className="fw-bold text-muted text-center">Estabelecendo comunicação com API da GalaxPay, aguarde...</p>
            </div>
            )}

            { actualPage === ActualPage.FORM && (
            <h5 className="text-center">Essa ação irá cancelar a cobrança na galaxpay. Deseja prosseguir?</h5>
            )}

            { actualPage === ActualPage.SUCCESS && (
            <div className="d-flex align-items-center justify-content-center text-center" style={{ minHeight: 400 }}>
              <p className="fw-bold text-muted">De acordo com a a resposta do sistema da GalaxPay, a cobrança foi cancelada com sucesso!</p>
            </div>
            )}

            {actualPage === ActualPage.ERROR && (
            <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ minHeight: 400 }}>
              <p className="fw-bold text-muted">Ocorreu um erro ao excluir a cobrança.</p>
              {error !== '' && (
              <p className="fw-bold text-danger mt-4 fw-bold">
                {error}
                .
              </p>
              )}
            </div>
            )}

          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" style={{ backgroundColor: 'gray' }} data-bs-dismiss="modal" onClick={() => closeAndFetch()}>Fechar</button>
            {actualPage === ActualPage.FORM && (
              <button type="button" className="btn btn-primary" onClick={() => tryCancelCharge()} style={{ backgroundColor: 'Orange' }}>Cancelar cobrança</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
